import styled from 'styled-components'

export default styled.h1`
  margin-top: 5vh;
  margin-bottom: 7vh;
  text-transform: uppercase;

  @media (max-width: 991px) {
    text-align: center;
  }
`
